const InsuredData = ({
  Document,
  Name,
}) => ({
  document: Document ?? '',
  name: Name ?? '',
})

export default InsuredData
